import React from "react";
import { useLocation } from "react-router-dom";
import { Typography, Box } from "@mui/material";
import { COLORS } from "constants/colors";
import AppLayout from "../components/AppLayout";
import StyledButton from "../components/StyledButton";
import { createPayPayTicketQrCode } from "utils/api";
import { useUrlParams } from "hooks/useUrlParams";
import { useTheme } from "@emotion/react";

function ConfirmPayPay() {
  const { soulId } = useUrlParams();
  const location = useLocation();
  const theme = useTheme();

  const queryParams = new URLSearchParams(location.search);
  const episodeId = queryParams.get("episode_id");
  const ticketKey = queryParams.get("ticket_key");

  const [isDisabled, setIsDisabled] = React.useState(false);

  const handleRedirect = async () => {
    setIsDisabled(true);
    try {
      const { data } = await createPayPayTicketQrCode(
        soulId,
        episodeId,
        ticketKey
      );
      window.location.href = data.url;
    } catch (error) {
      console.error("Error creating PayPay QR code:", error);
      return;
    }
  };

  return (
    <AppLayout page="PayPayTicketConfirm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: COLORS.BACKGROUND_WHITE,
            borderRadius: "5px",
            padding: 4,
            gap: 4,
          }}
        >
          {/* <Typography variant="h4" sx={{ fontSize: "15px", whiteSpace: "pre-line", fontWeight: "bold", textAlign: "center", color: COLORS.TEXT_BLACK, mt:1}}>
                {"PayPay購入時の注意"}
              </Typography> */}

          <Box>
            <Typography
              sx={(theme) => ({
                fontSize: "16px",
                whiteSpace: "pre-line",
                fontWeight: "bold",
                textAlign: "center",
                color: "#EB8010", // 落ち着いたオレンジ文字
                backgroundColor: "#FFF9EE", // 薄オレンジ背景
                border: "1px solid #FFD591", // 枠線もやさしめ
                borderRadius: "6px",
                padding: "10px 14px",
                lineHeight: "1.6",
                mt: 1,
              })}
            >
              PayPay決済が完了しても、LINEに戻るまでPayPayアプリを閉じずにそのままお待ちください。
            </Typography>
          </Box>

          <StyledButton
            variant="contained"
            sx={(theme) => ({
              width: "50%",
              fontSize: "17px",
              color: COLORS.TEXT_BLACK,
              border: `2px solid ${COLORS.TEXT_BLACK}`,
            })}
            onClick={handleRedirect}
            disabled={isDisabled}
          >
            購入する
          </StyledButton>
        </Box>
      </Box>
    </AppLayout>
  );
}

export default ConfirmPayPay;
